import { apiClient } from "..";
import { StatsTodayResponse, StatsWeeklyResponse, CargoStatsResponse } from "../types/stats";
import { logger } from "@/lib/logger";

export class StatsService {
  static async getToday(): Promise<StatsTodayResponse> {
    return apiClient.get<StatsTodayResponse>("/stats/today");
  }

  static async getWeekly(): Promise<StatsWeeklyResponse> {
    return apiClient.get<StatsWeeklyResponse>("/stats/weekly");
  }

  static async getCargoStats(startDt: string, endDt: string): Promise<CargoStatsResponse> {
    return apiClient.post<CargoStatsResponse>("/stats/cargo", { startDt, endDt });
  }

  /**
   * 입출고 현황 Excel 다운로드
   */
  static async exportCargoStatsToExcel(startDt: string, endDt: string): Promise<void> {
    try {
      logger.info("입출고 현황 Excel 다운로드 요청:", { startDt, endDt });

      const blob = await apiClient.downloadBlob("/stats/cargo/excel", { startDt, endDt });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `cargo-stats_${startDt}_${endDt}.xlsx`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      logger.info("입출고 현황 Excel 다운로드 완료");
    } catch (error) {
      logger.error("입출고 현황 Excel 다운로드 실패:", error);
      throw error;
    }
  }
}
